module.exports = __webpack_public_path__ + "img/sala-de-estar.2523ed77.png";